(function($){
    $(document).ready(function(){
        setTimeout(function(){
            if($('.woocommerce-product-gallery').length > 0){
                var i = 1;
                $('.flex-control-nav.flex-control-thumbs li').each(function(){
                    $(this).attr('data-index', i);
                    i++;
                })
            }
        }, 2500)
    })
})(jQuery)